import { render } from "./MenuSuperAdmin.vue?vue&type=template&id=383a39a7&scoped=true"
import script from "./MenuSuperAdmin.vue?vue&type=script&lang=js"
export * from "./MenuSuperAdmin.vue?vue&type=script&lang=js"

import "./MenuSuperAdmin.vue?vue&type=style&index=0&id=383a39a7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383a39a7"]])

export default __exports__